import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";

import Routes from "./routes";
import getLineProfile from "./utils/getLineProfile";
import { Loading } from "./components";
import {
  ERROR,
  TIMEOUT,
  PRESCRIPTION_MEDICATION_GUIDANCE,
  PRODUCT_DELIVERY_SELECT_CREDIT_CARD,
  PRODUCT_DELIVERY_SELECT_PAYMENT_METHOD,
  PRODUCT_DELIVERY_COMPLETE_PAYMENT,
  PRODUCT_DELIVERY_ERROR,
  NAVIGATE_PAY,
  CONFIRMING_PAY,
  PRODUCT_DELIVERY_START_PAY,
  PRODUCT_DELIVERY_CONFIRMING_PAY,
} from "./routes/path";

function App() {
  const [lineId, setLineId] = useState("");
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    if (
      [
        ERROR,
        TIMEOUT,
        PRESCRIPTION_MEDICATION_GUIDANCE,
        PRODUCT_DELIVERY_SELECT_CREDIT_CARD,
        PRODUCT_DELIVERY_SELECT_PAYMENT_METHOD,
        PRODUCT_DELIVERY_COMPLETE_PAYMENT,
        PRODUCT_DELIVERY_ERROR,
        NAVIGATE_PAY,
        CONFIRMING_PAY,
        PRODUCT_DELIVERY_START_PAY,
        PRODUCT_DELIVERY_CONFIRMING_PAY,
      ].includes(window.location.pathname)
    ) {
      setShowLoading(false);
      return;
    }
    const getProfile = async () => {
      const profile = await getLineProfile();
      setLineId(profile.userId);
      setShowLoading(false);
    };

    if (!lineId) {
      getProfile();
    }
  }, [lineId]);

  var judgeDeviceType = function () {
    var ua = window.navigator.userAgent.toLocaleLowerCase();
    var isAndroid = /android/.test(ua);
    return isAndroid;
  };

  function fixedViewportHeight() {
    let metaEl = document.querySelector("meta[name=viewport]");
    let content = [];
    content.push("width=device-width");
    content.push("initial-scale=1.0");
    content.push("user-scalable=no");
    metaEl.setAttribute("content", content.join(","));
  }

  useEffect(() => {
    if (judgeDeviceType()) {
      fixedViewportHeight(true);
    }
  }, []);

  return (
    <>
      <Loading open={showLoading} />
      {!showLoading && (
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
